import { Badge } from "@/components/ui/badge";

export function ProbBar({ name, probability, rationale }) {
  const pct = Math.max(0, Math.min(100, Number(probability) || 0));
  return (
    <div className="rounded-md border border-border bg-card p-4">
      <div className="mb-1.5 flex items-center justify-between gap-3">
        <span className="font-medium text-foreground">{name}</span>
        <span className="text-sm font-semibold text-primary">{pct}%</span>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-muted">
        <div className="prob-bar h-full rounded-full bg-primary" style={{ width: `${pct}%` }} />
      </div>
      {rationale && <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{rationale}</p>}
    </div>
  );
}

export function SectionTitle({ children, sub }) {
  return (
    <div className="mb-5">
      <h2 className="font-heading text-2xl font-semibold text-foreground">{children}</h2>
      {sub && <p className="mt-1 text-sm text-muted-foreground">{sub}</p>}
    </div>
  );
}

export function CategoryBadge({ children }) {
  const map = {
    Lab: "bg-blue-50 text-blue-800 border-blue-200",
    Imaging: "bg-purple-50 text-purple-800 border-purple-200",
    Pathology: "bg-rose-50 text-rose-800 border-rose-200",
    Other: "bg-secondary text-secondary-foreground border-border",
  };
  return (
    <Badge variant="outline" className={map[children] || map.Other}>
      {children}
    </Badge>
  );
}
